import requestHandler from '../requestHandler';

const getAdvisorOwnDetails = () =>
  requestHandler.get(`/api/v1/distributor-admin/self`, {});

export default getAdvisorOwnDetails;
